var styles = {"left":"RegularBox-module_left__yyTIy","center":"RegularBox-module_center__j-gSx","right":"RegularBox-module_right__-3G7I"};

export { styles as default };
//# sourceMappingURL=RegularBox.module.scss.js.map
